import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateLunchStatus } from "slices/citySlice"; 

const LunchStatusSwitch = ({ userLunchStatus }) => {
  const dispatch = useDispatch();

  const [status, setStatus] = useState(0);

  useEffect(() => {
    if (userLunchStatus?.lunch_status !== undefined) {
      setStatus(Number(userLunchStatus.lunch_status));
    }
  }, [userLunchStatus?.lunch_status]);

  const handleToggle = () => {
    const newStatus = status === 1 ? 0 : 1;
    setStatus(newStatus);

    dispatch(updateLunchStatus(newStatus, (success, message) => {
      if (success) {
        console.log("Updated:", message);
      } else {
        console.error("Failed:", message);
      }
    }));
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <div
        onClick={handleToggle}
        style={{
          width: "50px",
          height: "25px",
          borderRadius: "15px",
          background: status === 0 ? "#1AD598" : "#C6C3BD",
          cursor: "pointer",
          position: "relative",
          transition: "0.3s"
        }}
      >
        <div
          style={{
            width: "20px",
            height: "20px",
            background: "white",
            borderRadius: "50%",
            position: "absolute",
            top: "2.5px",
            left: status === 0 ? "26px" : "4px",
            transition: "0.3s"
          }}
        />
      </div>

      <span style={{ fontWeight: "bold", color: status === 0 ? "#1AD598" : "#C6C3BD" }}>
        {status === 0 ? "Online" : "Offline"}
      </span>
    </div>
  );
};

export default LunchStatusSwitch;
